var __jsx = React.createElement;
import React, { useState } from 'react';
import { useTranslation } from "@i18n";
var FAQSection = function FAQSection(_ref) {
  var data = _ref.data;
  var _useState = useState(false),
    showAllFaqs = _useState[0],
    setShowAllFaqs = _useState[1];
  var _useState2 = useState(false),
    mounted = _useState2[0],
    setMounted = _useState2[1];
  var _useTranslation = useTranslation(["web_sell_trade"]),
    tShort = _useTranslation.tShort;
  React.useEffect(function () {
    setMounted(true);
  }, []);
  var faqs = data === null || data === void 0 ? void 0 : data.faq_items;
  var title = data === null || data === void 0 ? void 0 : data.tilte;
  var subtitle = data === null || data === void 0 ? void 0 : data.subtitle;
  return /*#__PURE__*/React.createElement("section", {
    id: "faq-section",
    className: "my-4 md:my-10 px-5 md:px-4"
  }, /*#__PURE__*/React.createElement("div", {
    id: "faq-container",
    className: "mx-auto md:max-w-[1200px]"
  }, /*#__PURE__*/React.createElement("h2", {
    id: "faq-title",
    className: "text-[20px] font-bold text-primary-new text-center mb-2 md:mb-5 md:text-[40px]"
  }, title), /*#__PURE__*/React.createElement("p", {
    id: "faq-subtitle",
    className: "text-[14px] font-medium text-[#020202] text-center mb-10 md:mb-8 md:text-[20px] leading-10"
  }, subtitle), /*#__PURE__*/React.createElement("div", {
    id: "faq-items-container",
    className: "space-y-4"
  }, faqs.map(function (faq, index) {
    return /*#__PURE__*/React.createElement("details", {
      id: "faq-item-".concat(index),
      key: index,
      className: "border-[1px] border-solid border-[#D6DFE9] rounded-lg overflow-hidden group".concat(mounted && !showAllFaqs && index >= 4 ? ' hidden' : '')
    }, /*#__PURE__*/React.createElement("summary", {
      id: "faq-item-header-".concat(index),
      className: "flex justify-between items-center gap-2 p-5 sm:p-4 cursor-pointer transition-all duration-300 ease-in-out list-none"
    }, /*#__PURE__*/React.createElement("span", {
      id: "faq-item-question-".concat(index),
      className: "text-4 sm:text-3 sm:line-height-6 font-bold text-primary-new text-right rtl:text-right ltr:text-left"
    }, faq.question), /*#__PURE__*/React.createElement("span", {
      id: "faq-item-toggle-icon-".concat(index),
      className: "flex items-center justify-center text-primary-new shrink-0 w-6 h-6"
    }, /*#__PURE__*/React.createElement("svg", {
      className: "block group-open:hidden",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M7 10l5 5 5-5z"
    })), /*#__PURE__*/React.createElement("svg", {
      className: "hidden group-open:block",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M7 14l5-5 5 5z"
    })))), /*#__PURE__*/React.createElement("div", {
      id: "faq-item-answer-".concat(index),
      className: "p-[0_20px_20px] text-4 sm:text-3 sm:line-height-4 leading-[1.6] text-[#6B7EA5] text-right rtl:text-right ltr:text-left"
    }, faq.answer));
  })), faqs.length > 4 && /*#__PURE__*/React.createElement("button", {
    id: "faq-show-more-button",
    onClick: function onClick() {
      return setShowAllFaqs(!showAllFaqs);
    },
    className: "items-center block mx-auto mt-[30px] py-3 px-[30px] bg-primary-new text-white border-none rounded-[6px] text-[16px] font-semibold cursor-pointer transition-all duration-300 ease-in-out hover:bg-primary-new hover:translate-y-[-2px] hover:shadow-[0_4px_8px_rgba(0,0,0,0.1)]"
  }, showAllFaqs ? tShort('faq/show_less_button', {
    ns: 'web_sell_trade'
  }) : tShort('faq/show_more_button', {
    ns: 'web_sell_trade'
  }))));
};
export default FAQSection;